import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'checks', 'Checks', [["path",{"d":"M7 12l5 5l10 -10"}],["path",{"d":"M2 12l5 5m5 -5l5 -5"}]]);